<template>
  <main class="registro-cambios">
    <h3 class="d-none d-md-block">REGISTRO DE CAMBIOS</h3>
    <h3 class="d-md-none font-weight-bold">REGISTRO<br />DE CAMBIOS</h3>

    <!-- Introducción -->
    <div class="alert d-flex align-items-center mb-4" role="alert" style="background-color: #66C4DE; border-color: #66C4DE;">
      <i class="fas fa-history fa-2x" style="margin-right: 15px; color: #fff;"></i>
      <div>
        <p class="mb-0" style="color: #353535;">
          <strong>Aquí encuentras la historia de avances de CentralGym.</strong>
          Cada hito muestra las novedades, mejoras y correcciones incorporadas al sistema,
          de la versión más reciente a la más antigua.
        </p>
      </div>
    </div>

    <!-- Leyenda de tipos -->
    <div class="leyenda mb-4">
      <span class="leyenda-item"><span class="tag tag-nuevo">Nuevo</span> Funcionalidad nueva</span>
      <span class="leyenda-item"><span class="tag tag-mejora">Mejora</span> Optimización o cambio</span>
      <span class="leyenda-item"><span class="tag tag-correccion">Corrección</span> Arreglo de un problema</span>
    </div>

    <!-- Línea de tiempo -->
    <div class="timeline">
      <div
        v-for="(entry, index) in entries"
        :key="entry.version"
        class="timeline-item"
      >
        <div class="timeline-marker">
          <span class="timeline-dot" :class="{ 'is-current': index === 0 }"></span>
        </div>
        <div class="timeline-content">
          <div class="version-card">
            <div class="version-head">
              <div class="version-meta">
                <span class="version-pill" :class="{ 'is-current': index === 0 }">v{{ entry.version }}</span>
                <span v-if="index === 0" class="badge-actual">Versión actual</span>
              </div>
              <span class="version-date">
                <i class="far fa-calendar-alt me-1"></i>{{ formatDate(entry.date) }}
              </span>
            </div>
            <ul class="version-changes">
              <li v-for="(item, i) in entry.items" :key="i" class="change-row">
                <span class="tag" :class="'tag-' + item.type">{{ tagLabel(item.type) }}</span>
                <span class="change-text">{{ item.text }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import changelog from './changelogData.js';

const MESES = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
];

export default {
  name: 'RegistroDeCambios',
  data() {
    return {
      entries: changelog
    };
  },
  methods: {
    tagLabel(type) {
      if (type === 'nuevo') return 'Nuevo';
      if (type === 'correccion') return 'Corrección';
      return 'Mejora';
    },
    // Convierte 'YYYY-MM-DD' a "DD de <mes> de YYYY".
    formatDate(iso) {
      if (!iso) return '';
      const [y, m, d] = iso.split('-').map(Number);
      if (!y || !m || !d) return iso;
      return `${d} de ${MESES[m - 1]} de ${y}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.registro-cambios {
  padding-bottom: 20px;
}

/* ===== Leyenda ===== */
.leyenda {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  background: #fff;
  border-radius: 12px;
  padding: 14px 18px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.leyenda-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #66615b;
}

/* ===== Etiquetas de tipo ===== */
.tag {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  padding: 3px 8px;
  border-radius: 6px;
  white-space: nowrap;
  flex-shrink: 0;
}

.tag-nuevo {
  background: rgba(107, 208, 152, 0.18);
  color: #2f9e63;
}

.tag-mejora {
  background: rgba(102, 196, 222, 0.18);
  color: #2b8bab;
}

.tag-correccion {
  background: rgba(239, 129, 87, 0.18);
  color: #d35f3a;
}

/* ===== Línea de tiempo ===== */
.timeline {
  position: relative;
  margin-left: 8px;
}

/* Línea vertical continua */
.timeline::before {
  content: '';
  position: absolute;
  left: 7px;
  top: 6px;
  bottom: 6px;
  width: 2px;
  background: #e3e6ea;
}

.timeline-item {
  position: relative;
  display: flex;
  gap: 22px;
  padding-bottom: 22px;

  &:last-child {
    padding-bottom: 0;
  }
}

.timeline-marker {
  position: relative;
  flex-shrink: 0;
  width: 16px;
}

.timeline-dot {
  position: absolute;
  top: 6px;
  left: 0;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  border: 3px solid #c7ccd2;
  z-index: 1;

  &.is-current {
    border-color: #6bd098;
    box-shadow: 0 0 0 4px rgba(107, 208, 152, 0.18);
  }
}

.timeline-content {
  flex: 1 1 auto;
  min-width: 0;
}

/* ===== Tarjeta de versión ===== */
.version-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px 18px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.18s ease;

  &:hover {
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.10);
  }
}

.version-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f2f2f2;
}

.version-meta {
  display: flex;
  align-items: center;
  gap: 10px;
}

.version-pill {
  font-size: 15px;
  font-weight: 700;
  color: #66615b;
  background: #f4f4f4;
  border-radius: 8px;
  padding: 4px 12px;

  &.is-current {
    background: #6bd098;
    color: #fff;
  }
}

.badge-actual {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #2f9e63;
  background: rgba(107, 208, 152, 0.15);
  border-radius: 6px;
  padding: 3px 8px;
}

.version-date {
  font-size: 13px;
  color: #9a9a9a;
}

.version-changes {
  list-style: none;
  margin: 0;
  padding: 0;
}

.change-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 7px 0;

  & + .change-row {
    border-top: 1px dashed #f0f0f0;
  }
}

.change-text {
  font-size: 14px;
  color: #4a4a4a;
  line-height: 1.5;
}

@media (max-width: 575.98px) {
  .timeline-item {
    gap: 14px;
  }

  .version-card {
    padding: 14px;
  }

  .change-row {
    flex-direction: column;
    gap: 4px;
  }
}
</style>
